import AudioCubeApiCallerInstance from '../utils/AudioCubeApiCallerInstance';
import { SOUNDBOX_API_ENDPOINTS } from '../URLConstants';

export const AdminLogin = async (payload) => {
  const response = await AudioCubeApiCallerInstance.post(
    SOUNDBOX_API_ENDPOINTS.ADMIN_SIGN_IN,
    payload
  );
  return response;
};

export const AdminLoginForOtp = async (payload) => {
  const response = await AudioCubeApiCallerInstance.post(
    SOUNDBOX_API_ENDPOINTS.ADMIN_OTP_SIGN_IN,
    payload
  );
  return response;
};

export const adminLogOut = async () => {
  const response = await AudioCubeApiCallerInstance.post(SOUNDBOX_API_ENDPOINTS.ADMIN_SIGN_OUT);
  return response;
};

export const ForgetPasswordRequest = async (emailId) => {
  const response = await AudioCubeApiCallerInstance.post(SOUNDBOX_API_ENDPOINTS.FORGET_PASSWORD, {
    email: emailId
  });
  return response;
};

export const ResetPassword = async (token, password) => {
  const response = await AudioCubeApiCallerInstance.post(SOUNDBOX_API_ENDPOINTS.RESET_PASSWORD, {
    newPassword: password,
    token
  });
  return response;
};

export const AddNewZone = async (payload) => {
  const response = await AudioCubeApiCallerInstance.post(
    SOUNDBOX_API_ENDPOINTS?.CREATE_ZONE,
    payload
  );

  return response;
};

export const AddNewRegion = async (payload) => {
  const response = await AudioCubeApiCallerInstance.post(
    SOUNDBOX_API_ENDPOINTS?.CREATE_REGION,
    payload
  );

  return response;
};

export const AddNewBranch = async (payload) => {
  const response = await AudioCubeApiCallerInstance?.post(SOUNDBOX_API_ENDPOINTS?.CREATE_BRANCH, {
    branches: [payload]
  });
};

export const AddNewUserToNox = async (payload) => {
  const response = await AudioCubeApiCallerInstance?.post(
    SOUNDBOX_API_ENDPOINTS?.CREATE_USER_IN_ORGANIZATION,
    payload
  );
  return response;
};

export const BulkCreateUsers = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await AudioCubeApiCallerInstance.post(
    SOUNDBOX_API_ENDPOINTS.USERS_BULK_UPLOAD,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  );
  return response;
};

export const UpdateUserToNox = async (userId, payload) => {
  const response = await AudioCubeApiCallerInstance?.patch(
    `${SOUNDBOX_API_ENDPOINTS?.CREATE_USER_IN_ORGANIZATION}/${userId}`,
    payload
  );
  return response;
};

export const ActivateUser = async (userId) => {
  const response = await AudioCubeApiCallerInstance.post(
    `${SOUNDBOX_API_ENDPOINTS?.CREATE_USER_IN_ORGANIZATION}/${userId}/activate`
  );
  return response;
};
export const DeActivateUser = async (userId) => {
  const response = await AudioCubeApiCallerInstance.post(
    `${SOUNDBOX_API_ENDPOINTS?.CREATE_USER_IN_ORGANIZATION}/${userId}/deactivate`
  );
  return response;
};

export const DeleteUser = async (userId) => {
  const response = await AudioCubeApiCallerInstance.delete(
    `${SOUNDBOX_API_ENDPOINTS?.CREATE_USER_IN_ORGANIZATION}/${userId}`
  );
  return response;
};

export const GetUserById = async (userId) => {
  const response = await AudioCubeApiCallerInstance.get(
    `${SOUNDBOX_API_ENDPOINTS?.CREATE_USER_IN_ORGANIZATION}/${userId}`
  );
  return response;
};

export const ValidateLoginOTP = async (email, otp) => {
  const response = await AudioCubeApiCallerInstance.post(
    SOUNDBOX_API_ENDPOINTS.ADMIN_VALIDATE_LOGIN_OTP,
    {
      email,
      otp
    }
  );
  return response;
};

export const ChangePassword = async (oldPassword, newPassword) => {
  const response = await AudioCubeApiCallerInstance.patch(SOUNDBOX_API_ENDPOINTS.CHANGE_PASSWORD, {
    oldPassword,
    newPassword
  });
  return response;
};

export const ExportUsers = async () => {
  const response = await AudioCubeApiCallerInstance.get(
    `${SOUNDBOX_API_ENDPOINTS.EXPORT_USERS_URL}?exportType=excel`,
    {
      responseType: 'blob'
    }
  );
  return response;
};
